import React from 'react';
import './style.scoped.scss';
import { Button, Modal } from 'react-bootstrap';
import { IoMdClose } from 'react-icons/io';

const ConfirmationModal = ({ show, handleClose, plan, handleConfirm }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title>Confirm your Selection</Modal.Title>
        <IoMdClose onClick={handleClose} style={{ cursor: 'pointer' }} />
      </Modal.Header>
      <Modal.Body>
        <p style={{ fontSize: '1.25rem' }}>
          You have selected the <b>{plan.title} Plan</b>. Please confirm your
          selection.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div className='d-flex flex-row justify-content-between w-100'>
          <Button variant='danger' onClick={handleClose}>
            Cancel
          </Button>
          <Button variant='primary' onClick={handleConfirm}>
            Confirm
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
